module.exports = __webpack_public_path__ + "img/my-games-cloud.f86972aa.webp";